import { TranslateService } from "@ngx-translate/core";
import { Directive, OnDestroy } from "@angular/core";
import { TranslateConfigService } from "../services/translate-config.service";
import { Subject } from "rxjs";
import { distinctUntilChanged, filter, take, takeUntil } from "rxjs/operators";

@Directive()
export class ComponentBase implements OnDestroy {
  destroy$: Subject<unknown> = new Subject();
  constructor(
    protected translateService: TranslateConfigService,
    protected translate: TranslateService
  ) {
    this.initTranslate();
  }

  initTranslate() {
    this.translateService.langChangeObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.translate.use(lang);
      });

    // this.translateService.translateionchanged$.pipe(takeUntil(this.destroy$),distinctUntilChanged((old: any,neww:any)=> JSON.stringify(old) !== JSON.stringify(neww))).subscribe((translation)=>{
    //   this.translate.setTranslation(this.translate.currentLang,translation)
    // })
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
